import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter } from "react-router-dom";

const container = document.getElementById("root");
const root = createRoot(container);

// Add Google AdSense meta tag dynamically
const addAdSenseMeta = () => {
  const meta = document.createElement("meta");
  meta.name = "google-adsense-account";
  meta.content = "ca-pub-9823458531854966"; // Replace with your AdSense ID
  document.head.appendChild(meta);
};
// --- Load Google AdSense ---
const loadAdSense = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src =
    "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9823458531854966"; // Replace with your AdSense client ID
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);
};
loadAdSense();
root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>

);
